import { render, staticRenderFns } from "./leaderboardRanking.vue?vue&type=template&id=13bd7bde&lang=pug"
import script from "./leaderboardRanking.vue?vue&type=script&lang=js"
export * from "./leaderboardRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports